import { render, staticRenderFns } from "./CatalogSelect.vue?vue&type=template&id=fca96310&"
import script from "./CatalogSelect.vue?vue&type=script&lang=js&"
export * from "./CatalogSelect.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports